<template>
<div ref="invoice" :id="'invoice' + invoice.meta.key">
    <div style="font-size:30px">INVOICE <span style="color:#bbb">{{getInvoiceId(invoice)}}</span></div> 
    <table>
        <tr>
            <td valign="top" align="right" style="padding:3px"><b>To:</b></td>
            <td style="padding:3px">
                {{invoice.to.firstName}} {{invoice.to.lastName}} (invoice date {{invoiceDate}})<br/>
                {{invoice.to.entity}}
            </td>
        </tr>
        <tr>
            <td valign="top" align="right" style="padding:3px"><b>From:</b></td>
            <td style="padding:3px">
                {{invoice.from.entity || invoice.from.firstName + ' ' + invoice.from.lastName}}<br/>
                {{invoice.from.address}} <b>Ph</b> {{invoice.from.mobile}}
            </td>
        </tr>
        <tr>
            <td align="right" style="padding:3px"><b>ABN:</b></td>
            <td style="padding:3px">{{invoice.from.abn}}</td>
        </tr>
        <tr>
            <td align="right" style="padding:3px"><b>Account:</b></td>
            <td style="padding:3px">{{invoice.from.account}}</td>
        </tr>
    </table> 

    <!-- Line Items -->

    <table width="100%">
        <tr v-for="charge in invoice.charges" :key="charge.meta.key">
            <td>
                {{charge.date | date}}
            </td>

            <div @click.stop>
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                    <td v-on="on" :title="formatStamp(charge.stamp)" style="cursor:pointer">
                    {{charge.clients}}
                    </td>
                    </template>
                    <v-list>
                        <v-list-item @click="deleteCharge(charge)">
                            <v-list-item-title>Delete Charge</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="isAdministrator" @click="debugCharge(charge)">
                            <v-list-item-title>Debug Charge</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
            
            <td>
                {{charge.description}}
            </td>
            <td>
                {{charge.brokerName}}
            </td>

            <td align="right">
                {{charge.amount}}
            </td>
        </tr>
    </table>

    <table style="width:100%">
        <tr>
            <td style="text-align:right;padding:3px;width:99%">Total:</td>
            <td style="text-align:right">{{invoice.total | cents}}</td>
        </tr>
        <tr>
            <td style="text-align:right;padding:3px;">+GST: </td>
            <td style="text-align:right">{{(invoice.total * 0.1) | cents}}</td>
        </tr>
        <tr>
            <td style="text-align:right;padding:3px;">Amount Payable:</td>
            <td style="text-align:right"><b>{{(invoice.total * 1.1) | cents}}</b></td>
        </tr>
    </table>
    <small>* Direct debit is on the {{nth}} of each month. Manual payments due by the 15th. Invoice email: {{invoice.to.email}} DDR: {{invoice.to.directDebitRef || '[none]'}}</small>
    
</div>  
</template>

<script>
import ContactHelpers from '@/helpers/ContactHelpers'
import DataHelpers from '@/helpers/DataHelpers'
import {getDate, getMonth, getYear, format, addMonths, lastDayOfMonth} from 'date-fns'
import FirebaseHelpers from '@/helpers/FirebaseHelpers'
import DateHelpers from '../../helpers/DateHelpers'


export default {
data () {
    return {
        
    }
},

props: {
    invoice: Object
},

computed: {
    nth() {
        if(DataHelpers.isInsightUser(this.invoice.to))
            return '28th'

        return '21st'
    },
    invoiceHTML() {
        return this.$refs.invoice.outerHTML
    },
    invoiceDate() {
        const dateString = this.invoice.month + '-01'
        const startOfMonth = new Date(dateString)
        const startOfNextMonth = addMonths(startOfMonth, 1)
        return DateHelpers.dateToAu(startOfNextMonth)
    }
},

methods: {

    formatStamp(stamp) {
        return DataHelpers.formatStamp(stamp)
    },

    getInvoiceId(invoice) {

        if(!invoice.meta)
            return ''

        let payer = invoice.to
        let initials = ContactHelpers.initials(payer) + payer.lastName[payer.lastName.length -1].toUpperCase()
        
        let recipient = invoice.from
        let recipientInitials = ContactHelpers.initials(recipient)

        const [year, month] = invoice.month.split('-')
        const singleDigitYear = (year - 2020)

        
        return initials + recipientInitials + '-' + month + singleDigitYear
    },

    isAdministrator() {
        const userEmail = this.user.email
        return userEmail == 'matt.ireland.home@gmail.com' 
        // || userEmail == 'shannon.mcleish@insightprocessing.com.au'
    },

    deleteCharge(charge) {
        this.$emit('delete-charge', charge)
    },

    debugCharge(charge) {
        FirebaseHelpers.viewInConsole(charge.meta.path + '/' + charge.meta.key)
    },

},

mounted() {
    Object.defineProperty(this.invoice, 'html', {
        get: () => this.invoiceHTML  
    })
}



}
</script>

<style>

</style>


// WEBPACK FOOTER //
// Invoice.vue?2db9c1aa